<div class="alert alert-info">
    <p>
        <span class="fal fa-info-circle right-buffer left-buffer"></span>
        Please configure your personal data privacy settings below and click
        "OK" once you are satisfied.
    </p>
    <p class="help-block">
        For more information visit
        <a href="https://flyfreely.io/data-collection-notice" target="_blank">
            https://flyfreely.io/data-collection-notice
        </a>
    </p>
    <p class="help-block">
        Note - These settings can be changed later from your profile settings in
        the "Privacy" tab
    </p>
    <div class="fill top-buffer" [formGroup]="form">
        <table class="table" style="width: 100%; max-width: 36rem">
            <tbody>
                <tr>
                    <td>
                        Allow the app to collect data to improve performance and
                        stability
                    </td>
                    <td>
                        <mat-slide-toggle
                            formControlName="allowSentry"
                        ></mat-slide-toggle>
                    </td>
                </tr>
                <tr>
                    <td>
                        Allow the app to collect data to improve the product
                    </td>
                    <td>
                        <mat-slide-toggle
                            formControlName="allowMixpanel"
                        ></mat-slide-toggle>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            (click)="updateUserPrivacySettings()"
                        >
                            OK
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
